import React from 'react';
import qs from 'query-string';
import { useLocation } from 'react-router-dom';

import {
  ExternalUnsubscribePageGradientLeft,
  ExternalUnsubscribePageGradientRight,
} from '@uikit/old/ExternalUnsubscribePageGradients/ExternalUnsubscribePageGradients';
import { Button } from '@uikit/Form/Button/Button';

// @ts-ignore
import responaLogo from 'src/assets/ResponaLogoLarge.svg';

import './MaintenancePage.scss';
import { isStandaloneMode } from '@constants/app-modes';
import { getSafeInternalPath } from '@utils/url.utils';

const safeDecode = (value: string): string => {
  try {
    return decodeURI(value);
  } catch (e) {
    return value;
  }
};

function MaintenancePage({
  errorTitle = "We're upgrading your outreach experience.",
  errorText = "We're undergoing a new update. We’ll be back online soon.",
}: {
  errorTitle?: string;
  errorText?: string;
}) {
  const { search } = useLocation();
  const { redirect, message } = qs.parse(search);
  // Only same-origin paths may be used as the "Try Again" target (open-redirect guard)
  const safeRedirect = redirect ? getSafeInternalPath(redirect, '') : '';
  const messageText = typeof message === 'string' ? safeDecode(message) : '';

  return (
    <div className="maintenance-page">
      {isStandaloneMode() ? (
        <a href="/" className="maintenance-page__logo-container">
          <img alt="Logo" src={responaLogo} className="maintenance-page__logo" />
        </a>
      ) : null}

      <ExternalUnsubscribePageGradientLeft />
      <ExternalUnsubscribePageGradientRight />

      <div className="maintenance-page__content">
        <div className="maintenance-page__message">
          {messageText ? (
            <h1 className="maintenance-page__title">Error</h1>
          ) : (
            <h1 className="maintenance-page__title">{errorTitle}</h1>
          )}

          {messageText ? (
            <p className="maintenance-page__sub-title">{messageText}</p>
          ) : (
            <>
              <p className="maintenance-page__sub-title">{errorText}</p>
              {isStandaloneMode() && (
                <p className="maintenance-page__sub-title maintenance-page__contact">
                  Questions? Don&apos;t hesitate to get in touch with us via{' '}
                  <a href="mailto:support@respona.com">support@respona.com</a>
                </p>
              )}
            </>
          )}

          {safeRedirect ? (
            <Button href={safeRedirect} className="maintenance-page__refresh-btn">
              Try Again
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default MaintenancePage;
